import Layer from "./Layer.js";

/**
 * @class CanvasLayer
 */
export default class CanvasLayer extends Layer {
  /**
   * @param {Spinner} spinner
   * @param {HTMLElement} node
   * @param {HTMLElement} [subjectNode]
   */
  constructor(spinner, node, subjectNode) {
    super(spinner, node, subjectNode);

    this.canvasContext = null;
    this.imageBitmap = null;
    this.subjectSizeHash = null;
  }

  init() {
    this.canvasContext = this.subject.getContext("2d", {
      alpha: false,
      desynchronized: true,
      antialias: false,
    });
  }

  setSize(width, height) {
    const ratio = Math.ceil(window.devicePixelRatio);
    this.ratio = ratio;
    this.width = width;
    this.height = height;

    const scaledWidth = width * ratio;
    const scaledHeight = height * ratio;
    const subjectSizeHash = `${scaledWidth}x${scaledHeight}`;

    if (this.subjectSizeHash === subjectSizeHash) {
      return;
    }

    this.subjectSizeHash = subjectSizeHash;
    this.subject.width = scaledWidth;
    this.subject.height = scaledHeight;

    /*
     * Set the scale for high-DPI devices otherwise the image will appear blurry
     * on iPhone
     */
    this.canvasContext.setTransform(ratio, 0, 0, ratio, 0, 0);

    // #APP-414: this will cause the draw to be redone
    this.imageBitmap = null;
  }

  draw(imageBitmap, dimensions, callback) {
    if (this.imageBitmap === imageBitmap) {
      if (callback) callback();

      return;
    }

    this.imageBitmap = imageBitmap;
    const { x, y, width, height } = dimensions;
    const xCompensation = (this.width - width) / 2;
    const yCompensation = (this.height - height) / 2;

    requestAnimationFrame(() => {
      this.canvasContext.drawImage(
        this.imageBitmap,
        x + xCompensation,
        y + yCompensation,
        width,
        height,
      );

      if (callback) callback();
    });
  }
}
